import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ServerHealthService extends RestfulService<Models.Server> {

  constructor(private restService: RestService) {
    super(Models.Server);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('servers');
  }

}
